import { jsx as a } from "react/jsx-runtime";
import l from "clsx";
import { forwardRef as E } from "react";
import { FormItem as I } from "../form-item/form-item.js";
import { useFieldIds as $ } from "../hooks/useFieldIds.js";
import '../../../assets/form-textarea.css';const r = {
  "form-input": "_form-input_xbn02_1",
  "form-input--text-area": "_form-input--text-area_xbn02_26",
  "form-input__control": "_form-input__control_xbn02_31",
  "form-input--disabled": "_form-input--disabled_xbn02_36",
  "form-input--readonly": "_form-input--readonly_xbn02_46",
  "form-input--error": "_form-input--error_xbn02_63",
  "form-input--width-default": "_form-input--width-default_xbn02_244",
  "form-input--width-full-width": "_form-input--width-full-width_xbn02_248"
}, j = E(
  ({
    id: f,
    name: p,
    dataTestId: n,
    autocomplete: _,
    placeholder: s,
    disabled: o = !1,
    minLength: x,
    maxLength: c,
    readonly: e = !1,
    required: d = !1,
    hasDescription: b = !1,
    label: h,
    description: w,
    error: m,
    hideLabels: v,
    width: u = "default",
    marginBottom: y,
    ...F
  }, N) => {
    const t = !!m, i = $({
      id: f,
      isError: !!t,
      hasDescription: b
    });
    return /* @__PURE__ */ a(
      I,
      {
        fieldIds: i,
        label: h,
        description: w,
        error: m,
        hideLabels: v,
        marginBottom: y,
        children: /* @__PURE__ */ a(
          "div",
          {
            className: l(r["form-input"], {
              [r["form-input--text-area"]]: !0,
              [r["form-input--disabled"]]: o,
              [r["form-input--readonly"]]: e,
              [r["form-input--width-default"]]: u === "default",
              [r["form-input--width-full-width"]]: u === "full-width",
              [r["form-input--error"]]: t
            }),
            "data-testid": `form-input--${i.id}`,
            children: /* @__PURE__ */ a(
              "textarea",
              {
                id: f,
                name: p,
                "aria-describedby": i.describedBy,
                "aria-invalid": t ? "true" : void 0,
                "aria-disabled": o ? "true" : void 0,
                "aria-required": d ? "true" : void 0,
                "aria-readonly": e ? "true" : void 0,
                readOnly: e,
                disabled: o,
                required: d,
                ref: N,
                className: l(r["form-input__control"], {
                  [r["form-input--invalid"]]: t
                }),
                autoComplete: _,
                minLength: x,
                maxLength: c,
                "data-testid": n || `form-input-field--${i.id}`,
                placeholder: s,
                ...F
              }
            )
          }
        )
      }
    );
  }
);
j.displayName = "FormTextarea";
export {
  j as FormTextarea,
  j as default
};
